import { api } from './client'

export const listCertBatches = (programId) =>
  api.get(`/cert-batches/programs/${programId}`).then((r) => r.data)

export const createCertBatch = (programId, data) =>
  api.post(`/cert-batches/programs/${programId}`, data).then((r) => r.data)

export const getCertBatch = (id) =>
  api.get(`/cert-batches/${id}`).then((r) => r.data)

export const updateCertBatch = (id, data) =>
  api.put(`/cert-batches/${id}`, data).then((r) => r.data)

export const deleteCertBatch = (id) =>
  api.delete(`/cert-batches/${id}`).then((r) => r.data)

export const addEligibleRecipients = (batchId) =>
  api.post(`/cert-batches/${batchId}/recipients/add-eligible`).then((r) => r.data)

export const addRecipients = (batchId, enrollmentIds) =>
  api.post(`/cert-batches/${batchId}/recipients/add`, { enrollment_ids: enrollmentIds }).then((r) => r.data)

// Penerima yang tidak terdaftar sebagai peserta di LMS — untuk seminar dan
// webinar sekali jalan. Berkas XLSX atau CSV berkolom full_name + email.
export const importRecipients = (batchId, file) => {
  const formData = new FormData()
  formData.append('file', file)
  return api
    .post(`/cert-batches/${batchId}/recipients/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data)
}

export const removeRecipient = (batchId, recipientId) =>
  api.delete(`/cert-batches/${batchId}/recipients/${recipientId}`).then((r) => r.data)

export const issueCertBatch = (batchId) =>
  api.post(`/cert-batches/${batchId}/issue`).then((r) => r.data)

export const listAllRecipients = (programId, params = {}) =>
  api.get(`/cert-batches/programs/${programId}/recipients`, { params }).then((r) => r.data)

export const getEmailTemplate = (programId) =>
  api.get(`/cert-batches/programs/${programId}/email-template`).then((r) => r.data)

export const updateEmailTemplate = (programId, data) =>
  api.put(`/cert-batches/programs/${programId}/email-template`, data).then((r) => r.data)

export const resetEmailTemplate = (programId) =>
  api.delete(`/cert-batches/programs/${programId}/email-template`).then((r) => r.data)

export const listCollections = (programId) =>
  api.get(`/cert-batches/programs/${programId}/collections`).then((r) => r.data)

export const createCollection = (programId, data) =>
  api.post(`/cert-batches/programs/${programId}/collections`, data).then((r) => r.data)

export const updateCollection = (id, data) =>
  api.put(`/cert-batches/collections/${id}`, data).then((r) => r.data)

export const deleteCollection = (id) =>
  api.delete(`/cert-batches/collections/${id}`).then((r) => r.data)

// Public (no auth)
export const getPublicCollection = (slug) =>
  api.get(`/collections/${encodeURIComponent(slug)}`).then((r) => r.data)
